import React from "react";
import usePageTitle from "../hooks/usePageTitle";
import { useTranslation } from "react-i18next";
import "./LegalPage.css";

function PrivacyPage() {
  const { t } = useTranslation();
  usePageTitle(t("privacy.pageTitle"));

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <span className="last-updated">{t("privacy.lastUpdated")}</span>
          <h1 className="legal-title">{t("privacy.heroTitle")}</h1>
          <p className="legal-subtitle">{t("privacy.heroSubtitle")}</p>
        </div>
      </div>

      <div className="container">
        <div className="legal-content">
          <section className="legal-section">
            <h2>{t("privacy.s1Title")}</h2>
            <p>{t("privacy.s1Content")}</p>
            <ul>
              <li>{t("privacy.s1Item1")}</li>
              <li>{t("privacy.s1Item2")}</li>
              <li>{t("privacy.s1Item3")}</li>
              <li>{t("privacy.s1Item4")}</li>
              <li>
                <b>{t("privacy.s1Item5Prefix")}</b>
                {t("privacy.s1Item5Suffix")}
              </li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t("privacy.s2Title")}</h2>
            <p>{t("privacy.s2Content")}</p>
            <ul>
              <li>
                <b>{t("privacy.s2Item1Prefix")}</b>
                {t("privacy.s2Item1Suffix")}
              </li>
              <li>
                <b>{t("privacy.s2Item2Prefix")}</b>
                {t("privacy.s2Item2Suffix")}
              </li>
            </ul>
            <p>{t("privacy.s2Footer")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("privacy.s3Title")}</h2>
            <p>{t("privacy.s3Content")}</p>
            <ul>
              <li>{t("privacy.s3Item1")}</li>
              <li>{t("privacy.s3Item2")}</li>
              <li>{t("privacy.s3Item3")}</li>
              <li>{t("privacy.s3Item4")}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t("privacy.s4Title")}</h2>
            <p>{t("privacy.s4Content")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("privacy.s5Title")}</h2>
            <p>{t("privacy.s5Content")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("privacy.s6Title")}</h2>
            <p>{t("privacy.s6Content")}</p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
